import { render, staticRenderFns } from "./VendorsTable.vue?vue&type=template&id=42100f6c&"
import script from "./VendorsTable.vue?vue&type=script&lang=js&"
export * from "./VendorsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports